const ADVERTISING_CATEGORY = 'advertising';
const ANALYTICS_CATEGORY = 'analytics';

const CLARITY_PROJECT_ID = import.meta.env.VITE_APP_CLARITY_PROJECT_ID;
const UET_TAG_ID = import.meta.env.VITE_APP_UET_TAG_ID;

let clarityLoaded = false;

type ClarityQueueArgs = [command: string, options?: Record<string, unknown>];
type ClarityQueueFn = ((...args: ClarityQueueArgs) => void) & { q?: ClarityQueueArgs[] };

function ensureClarityQueue(): void {
  if (typeof window.clarity !== 'function') {
    const q: ClarityQueueFn = (...args: ClarityQueueArgs) => {
      q.q = q.q || [];
      q.q.push(args);
    };
    window.clarity = q;
  }
}

function loadBingUET(onLoad: () => void) {
  if (document.querySelector('script[src="//bat.bing.com/bat.js"]')) return;
  const script = document.createElement('script');
  script.src = '//bat.bing.com/bat.js';
  script.async = true;
  script.onload = onLoad;
  script.onerror = function (e) {
    console.error('Failed to load Bing UET script:', e);
  };
  document.head.appendChild(script);
}

function sendClarityConsent(
  adConsent: 'granted' | 'denied',
  analyticsConsent: 'granted' | 'denied'
) {
  if (typeof window.clarity === 'function') {
    window.clarity('consentv2', {
      ad_Storage: adConsent,
      analytics_Storage: analyticsConsent
    });
  }
}

function initClarity(adConsent: 'granted' | 'denied', analyticsConsent: 'granted' | 'denied') {
  if (clarityLoaded) return;
  if (UET_TAG_ID && CLARITY_PROJECT_ID) {
    window.uetq = window.uetq || [];
    window.uetq.push?.('event', 'clarity_integration', {
      clarityProjectId: CLARITY_PROJECT_ID
    });
    clarityLoaded = true;
  }
  sendClarityConsent(adConsent, analyticsConsent);
}

function loadClarity(projectId: string) {
  if (document.querySelector('script[data-clarity]')) return;
  // Make sure a queue exists so the next line is queued if Clarity isn't loaded yet
  ensureClarityQueue();
  // Pre-seed a conservative default to prevent "granted" before banner action
  sendClarityConsent('denied', 'denied');
  // Load the tag (no onload consent push; we’ll update via TrustArc events)const script = document.createElement('script');
  const script = document.createElement('script');
  script.setAttribute('data-clarity', 'true');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${projectId}`;
  script.onerror = function (e) {
    console.error('Failed to load Clarity script:', e);
  };
  document.head.appendChild(script);
}

function onConsentGranted(adConsent: 'granted' | 'denied', analyticsConsent: 'granted' | 'denied') {
  loadBingUET(() => initClarity(adConsent, analyticsConsent));
  loadClarity(CLARITY_PROJECT_ID);
}

function handleConsent() {
  let analyticsConsent: 'granted' | 'denied' = 'denied';
  let advertisingConsent: 'granted' | 'denied' = 'denied';

  const trusteCMA = window.truste?.cma;
  if (trusteCMA && typeof trusteCMA.callApi === 'function') {
    if (trusteCMA.callApi('getGDPRConsentDecision', ANALYTICS_CATEGORY)) {
      analyticsConsent = 'granted';
    }
    if (trusteCMA.callApi('getGDPRConsentDecision', ADVERTISING_CATEGORY)) {
      advertisingConsent = 'granted';
    }
  }
  onConsentGranted(advertisingConsent, analyticsConsent);
}

export { handleConsent as checkConsent };
